<span *ngIf="divider" class="tt-context-menu-item__separator" role="separator" aria-hidden="true"></span>
<span [ngClass]="icon" class="tt-context-menu-item__icon" aria-hidden="true"></span>
<span class="tt-context-menu-item__text" [attr.title]="text">{{ text }}<ng-content></ng-content></span>
